// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"styles-module__loadingWrapper___ogl0V","loadingImage":"styles-module__loadingImage___EjVRi"};